export interface AddTimingsResponseData {
  updated: boolean;
  audioMap?: { t: number; w: number }[];
  textReplaced?: boolean;
  message?: string;
  prompt?: boolean;
}

/**
 * Submits a transcript to the addTimings endpoint, handling the server's
 * confirmation prompt: when the server responds with `prompt: true` (the new
 * timings would replace a much richer existing sync map), ask the user to
 * confirm and retry with `force: true`.
 *
 * Returns undefined when the user declines the confirmation.
 */
export const submitTranscriptWithConfirmation = async (options: {
  confirmReplace: (message: string) => boolean;
  submit: (force: boolean) => Promise<{ data: AddTimingsResponseData }>;
}): Promise<AddTimingsResponseData | undefined> => {
  const response = await options.submit(false);

  if (response.data.updated || !response.data.prompt) {
    return response.data;
  }

  if (
    !options.confirmReplace(
      response.data.message ??
        "Are you sure you want to update this? All your previous sync points will be replaced"
    )
  ) {
    return undefined;
  }

  const forcedResponse = await options.submit(true);
  return forcedResponse.data;
};
